import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AppProvider, useApp } from './context/AppContext'
import { AuthProvider, useAuth } from './context/AuthContext'
import Toast from './components/Toast'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import CreateEvent from './pages/CreateEvent'
import EventOverview from './pages/EventOverview'
import { TodoList, Budget, Guests, Shopping, Madplan, MusicPage, TransportPage, VenuePage, TeamPage, FilesPage } from './pages/EventPages'
import Tidsplan from './pages/Tidsplan'
import Inventar from './pages/Inventar'
import Profile from './pages/Profile'

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: 16, color: '#9e9bbf' }}>henter...</div>
  if (!user) return <Navigate to="/" replace />
  return children
}

function ToastContainer() {
  const { toastMessage, showToast } = useApp()
  if (!toastMessage) return null
  return <Toast message={toastMessage} onClose={() => showToast(null)} />
}

function AppContent() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/event/create" element={<ProtectedRoute><CreateEvent /></ProtectedRoute>} />
          <Route path="/event/:eventId" element={<ProtectedRoute><EventOverview /></ProtectedRoute>} />
          <Route path="/event/:eventId/todo" element={<ProtectedRoute><TodoList /></ProtectedRoute>} />
          <Route path="/event/:eventId/tidsplan" element={<ProtectedRoute><Tidsplan /></ProtectedRoute>} />
          <Route path="/event/:eventId/inventar" element={<ProtectedRoute><Inventar /></ProtectedRoute>} />
          <Route path="/event/:eventId/budget" element={<ProtectedRoute><Budget /></ProtectedRoute>} />
          <Route path="/event/:eventId/guests" element={<ProtectedRoute><Guests /></ProtectedRoute>} />
          <Route path="/event/:eventId/shopping" element={<ProtectedRoute><Shopping /></ProtectedRoute>} />
          <Route path="/event/:eventId/meals" element={<ProtectedRoute><Madplan /></ProtectedRoute>} />
          <Route path="/event/:eventId/musik" element={<ProtectedRoute><MusicPage /></ProtectedRoute>} />
          <Route path="/event/:eventId/transport" element={<ProtectedRoute><TransportPage /></ProtectedRoute>} />
          <Route path="/event/:eventId/venues" element={<ProtectedRoute><VenuePage /></ProtectedRoute>} />
          <Route path="/event/:eventId/team" element={<ProtectedRoute><TeamPage /></ProtectedRoute>} />
          <Route path="/event/:eventId/files" element={<ProtectedRoute><FilesPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </AuthProvider>
  )
}
